// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "ba4cdaec835fe693fd4d8e656042fadc106e0683/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","688":"2b6b0509","774":"c5660826","777":"dfb468f1"}[chunkId] + ".chunk.js";
};